export default __webpack_public_path__ + "static/media/liquidations.9d7234d1.png";